export default __webpack_public_path__ + "static/media/smile4.8dc8092a.jpg";